import { postApiForgotResetpassword } from "./postApiForgotResetpassword";
import { postApiForgotSelectcredential } from "./postApiForgotSelectcredential";
import { postApiForgotValidatecaptcha } from "./postApiForgotValidatecaptcha";
import { postApiForgotValidatechallenge } from "./postApiForgotValidatechallenge";
import { postApiForgotValidatecode } from "./postApiForgotValidatecode";

export function forgotController() {
  return {
    postApiForgotSelectcredential,
    postApiForgotValidatecode,
    postApiForgotValidatechallenge,
    postApiForgotValidatecaptcha,
    postApiForgotResetpassword,
  };
}
